import {isToFile} from './helpers';

function reloadCaptcha($imgCaptcha) {
    $imgCaptcha.attr('src', `/sveden/update/captcha/captcha.php?sid=${Math.random()}`);
}

export function initHotLineIfNeed($container) {
    const $btnFeedbackSend = $container.find('.feedback-send');
    if ($btnFeedbackSend.length) {
        const $imgCaptcha = $container.find('.captcha');
        const $nameField = $container.find('[name="name"]');
        const $emailField = $container.find('[name="email"]');
        const $subjectField = $container.find('[name="subject"]');
        const $messageField = $container.find('[name="message"]');
        const $captchaField = $container.find('[name="captcha"]');

        if (isToFile()) {
            reloadCaptcha($imgCaptcha);
            $imgCaptcha.on('click', () => {
                reloadCaptcha($imgCaptcha);
            });
        }

        $container.on('click', '.feedback-send', () => {
            const $feedbackStatus = $container.find('.feedback-status');

            if (isToFile()) {
                const form = $container.find('.feedback-form').serialize();
                $nameField.parent().removeClass('has-error');
                $emailField.parent().removeClass('has-error');
                $subjectField.parent().removeClass('has-error');
                $messageField.parent().removeClass('has-error');
                $captchaField.parent().removeClass('has-error');
                $feedbackStatus.removeClass('bg-danger bg-success')
                    .html('<ul></ul>')
                    .addClass('hide');
                $_pro.ajax({
                    type: 'post',
                    url: '/sveden/update/feedback.php',
                    data: form,
                    dataType: 'json',
                    success(res) {
                        if (res.success) {
                            $feedbackStatus.html('Сообщение отправлено')
                                .addClass('bg-success')
                                .removeClass('hide');
                            $nameField.val('');
                            $emailField.val('');
                            $subjectField.val('');
                            $messageField.val('');
                            $captchaField.val('');
                            reloadCaptcha($imgCaptcha);
                        } else {
                            if (res.message) {
                                $feedbackStatus.html(`Сообщение не отправлено. ${res.message}`)
                                    .addClass('bg-danger')
                                    .removeClass('hide');
                            }
                            res.errorID.forEach((item, i, arr) => {
                                $container.find(`[name="${item}"]`).parent().addClass('has-error');
                            });
                            res.messages.forEach((item, i, arr) => {
                                $feedbackStatus.children('ul:first').append(`<li>${item}</li>`);
                                $feedbackStatus.addClass('bg-danger');
                                $feedbackStatus.removeClass('hide');
                            });
                            reloadCaptcha($imgCaptcha);
                            $captchaField.val('');
                        }
                    },
                });
            } else {
                $feedbackStatus.html('Недоступно в просмотре информации')
                    .addClass('bg-danger')
                    .removeClass('hide');
            }
        });
    }
}
